module.exports = __webpack_public_path__ + "img/36-green.88175fc5.svg";